import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { checkPermissions } from "components/Common/ChkPermissions";
import PopupWindow from "components/Common/PopupWindow";
import Loader from "components/Common/Loader";
import CantAccessPage from "components/Common/CantAccessPage";
import { FaCopy, FaRegClipboard } from "react-icons/fa";
import { getWorkOrderDetailsAPIURL } from "BaseComponentAPI/WorkOrderListAPI";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const WorkOrderDetails = () => {
    const authUser = useSelector((state) => state.Login);
    document.title = "Cockpit";

    const { woId } = useParams();

    const navigate = useNavigate();

    const storedPermissions = JSON.parse(localStorage.getItem("permissions")) || {};
    const { canRead } = checkPermissions(storedPermissions);

    const [loaderOption, setLoaderOption] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [popupType, setPopupType] = useState("");

    const [workOrderInfo, setWorkOrderInfo] = useState(
        [
            { label: "WO Serial : ", key: "woSerialNo" },
            { label: "WO Type : ", key: "woType", bold: true },
            { label: "WO Final Amount ₹ : ", key: "woFinalAmount", bold: true },
            { label: "First Exe. Date : ", key: "firstExecutionDate", bold: true },
            { label: "First Exe.Time : ", key: "firstExecutionTime", bold: true },
            { label: "Total Exe. Pending : ", key: "noOfExecutionPending", color: "red", bold: true },
            { label: "Total Product Exe. : ", key: "totalProductExecutions" },
            { label: "Total Exe. Created : ", key: "noOfExecutionCreatedAtSystem" },
            { label: "Total Exe. Completed : ", key: "noOfExecutionCompleted" },
            { label: "WO Booked At : ", key: "woBookedAt" },
            { label: "WO Booked By : ", key: "woBookedBy" },
            { label: "", key: "" },
            { label: "Payment Mode : ", key: "woPaymentMode" },
            { label: "Payment Status : ", key: "woPaymentStatus" },
            {
                label: "Message For Schedular : ",
                key: "messageForScheduler",
                color: "red",
                bold: true,
                fullWidth: true,
            },
            { label: "Is WO Cancelled : ", key: "isWoCancelled", bold: true },
            { label: "Cancellation At : ", key: "woCancellationDateTime" },
            { label: "Cancellation Reason : ", key: "woCancellationReason" },
            { label: "Cancellation Remark : ", key: "woCancellationRemark" },
            { label: "Cancellation By : ", key: "woCancellationBy" },
            { label: "Reserved Field : ", key: "reserverField" },
        ]
    );

    const [customerDetails, setCustomerDetails] = useState(
        [
            { label: "Customer Name : ", key: "customerName", bold: true },
            { label: "Mobile No : ", key: "customersPrimaryMobileNo" },
            { label: "Complaint Raised : ", key: "isWoComplaintRaised" },
            { label: "Billing Name : ", key: "billingName", bold: true },
            { label: "Alternate Mobile No : ", key: "customersSecondryMobileNo" },
            { label: "Complaint Count : ", key: "woComplaintCount" },
            {
                label: "Detail Address : ",
                key: "woDetailAddress",
                half: true,
                copy: true
            },
            {
                label: "Service Location : ",
                key: "woServiceLocation",
                half: true,
                copy: true
            },
        ]
    );

    const [productDetails, setProductDetails] = useState([
        { label: "Product Name : ", key: "productName", bold: true },
        { label: "Negoitiated Price ₹ : ", key: "negotiatedPrice", bold: true },
        { label: "Sr. No. : ", key: "srNo" },
        { label: "Product Sub Category : ", key: "productSubCategoryName" },
        { label: "MRP ₹ : ", key: "mrp" },
        { label: "Quantity : ", key: "qty" },
        { label: "Product Category : ", key: "productCategoryName" },
        { label: "Guarantee : : ", key: "guarantee" },
        { label: "Validity : ", key: "validity" },
        { label: "Executions : ", key: "productExecutions" },
        { label: "Sys. Executions : ", key: "" },
        { label: "Execution Interval : ", key: "executionInterval" },
        { label: "Execution Completed : ", key: "noOfExeCompleted" },
        { label: "Execution Pending : ", key: "noOfExePending", color: "red", bold: true },
        { label: "Is Gurantee Over : ", key: "isGuaranteeOver" },
        { label: "Gurantee Finish Date : ", key: "guaranteeFinishDate" },

    ])

    const [executionDetails, setExecutionDetails] = useState([
        { label: "Exe Serial : ", key: "exeSerialNo", bold: true },
        { label: "WO Serial : ", key: "woSerialNo" },
        { label: "Sr. No. : ", key: "srNo", bold: true },
        { label: "Exe. Date : ", key: "executionDate" },
        { label: "WO Type : ", key: "woType" },
        { label: "Execution No : : ", key: "executionNo" },
        { label: "Exe. Time : ", key: "executionTime", bold: true },
        { label: "Product Name : ", key: "exeProduct", bold: true },
        { label: "Payment Mode : ", key: "paymentMode" },
        { label: "Time Require : ", key: "executionTimeRequire" },
        { label: "Product Sub Category : ", key: "exeProductSubCategory" },
        { label: "Received Amount ₹ : ", key: "exeAmountReceived" },
        { label: "Execution Amount ₹ : ", key: "exeAmount" },
        { label: "Product Category : ", key: "exeProductCategory", color: "red", bold: true },
        { label: "Exe. Completed  : ", key: "isExecutionCompleted" },
        { label: "Field Executive : ", key: "fieldExecutiveName" },
        { label: "Execution Status : ", key: "executionStatus" },
        { label: "Exe. Completed At : ", key: "exeCompletedDatetime" },
        { label: "Telecaller Name : ", key: "telecallerName" },
        { label: "Scheduler Name : ", key: "schedulerName" },
        { label: "Cancellation At : ", key: "exeCancellationDatetime" },
        {
            label: "Message For Schedular : ",
            key: "messageForScheduler",
            color: "red",
            bold: true,
            fullWidth: true,
        },
        { label: "Cancellation By : ", key: "exeCancellationBy" },
        { label: "Exe. Cancelled : ", key: "isExecutionCancelled" },

    ])

    // console.log(JSON.stringify(productDetails))


    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => setIsPopupVisible(false);

    useEffect(() => {
        getData();
    }, [authUser])



    // ✅ Helper Functions (Schedular, WorkOrder, PaymentMode)
    const getData = async () => {
        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            try {
                const res = await axios.get(
                    `${getWorkOrderDetailsAPIURL}?userUUID=${authUser.headers.userUUID}&exeUUID=${woId}&woUUID="-"`,
                    {
                        headers: {
                            ...authUser.headers,
                            Authorization: `Bearer ${authUser.headers.access_token}`,
                        },
                    }
                );

                if (res.data.responseMsg == "Success") {
                    const apiData = res.data.data || {};
                    const master = apiData.workOrderMaster || {};
                    const address = apiData.workOrderAddress || {};
                    const products = apiData.workOrderDetails || [];
                    const executions = apiData.workOrderExecutions || [];


                    // ✅ Work Order Info
                    const formattedWorkOrderData = workOrderInfo.map((item) => ({
                        ...item,
                        value: master[item.key] ?? "",
                    }));
                    setWorkOrderInfo(formattedWorkOrderData);

                    // ✅ Customer Details
                    const formattedCustomerDetailsData = customerDetails.map((item) => {
                        let value = "";
                        if (item.key in master) value = master[item.key];
                        else if (item.key in address) value = address[item.key];
                        return { ...item, value };
                    });
                    setCustomerDetails(formattedCustomerDetailsData);

                    // ✅ Product Details (loop through each product record)
                    const formattedProducts = products.map((prod) =>
                        productDetails.map((item) => ({
                            ...item,
                            value: prod[item.key] ?? "",
                        }))
                    );

                    // ✅ Set state as an array of product detail groups
                    setProductDetails(formattedProducts);
                    // console.log("✅ Product Details Added: ", JSON.stringify(formattedProducts));

                    // ✅ Product Details (loop through each product record)
                    const formattedExecutions = executions.map((exe) =>
                        executionDetails.map((item) => ({
                            ...item,
                            value: exe[item.key] ?? "",
                        }))
                    );
                    setExecutionDetails(formattedExecutions)
                } else {
                    console.error("Schedular API Response Error: ", res.data.responseMsg);
                }
            } catch (err) {
                console.error("Error fetching schedular list: ", err);
                openPopup("Requested Data Not Found / 404", "warn");
            }
        }
    };




    if (!canRead) {
        return (
            <Container fluid className="page-content">
                <Breadcrumbs title="Users" breadcrumbItem="Work Order Details" />
                <CantAccessPage />
            </Container>
        );
    }

    if (loaderOption) return <Loader />;

    return (
        <div className="page-content">
            <Container fluid>
                <Breadcrumbs title="Users" breadcrumbItem="Work Order Details" />
                <Card>
                    <CardBody>

                        <div className="row">
                            <div className="col-sm-12">
                                {/* ✅ Back Button */}
                                <button
                                    type="button"
                                    className="btn btn-sm btn-warning"
                                    style={{ fontWeight: "500", fontSize: '12px', float: 'right' }}
                                    onClick={() => navigate('/workOrderList')} // navigate back to previous page
                                >
                                    Back To WO List
                                </button>
                            </div>
                        </div>

                        {/* Header */}
                        <div className="d-flex align-items-center mb-3">
                            <h5
                                style={{
                                    color: "#005194",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Work Order Information
                            </h5>
                            <hr
                                style={{
                                    flex: 1,
                                    borderTop: "2px solid #005194",
                                    marginTop: "10px",
                                }}
                            />

                        </div>

                        {/* Work Order Info Grid */}
                        <div className="container">
                            <div className="row">
                                {workOrderInfo.map((item, index) => {
                                    if (item.fullWidth) {
                                        return (
                                            <div
                                                key={index}
                                                className="col-12 mb-2"
                                                style={{
                                                    // borderTop: "1px solid #ccc",
                                                    // borderBottom: "1px solid #ccc",
                                                    // padding: "6px 0",
                                                }}
                                            >
                                                <span style={{ fontSize: '15px', fontWeight: '550', color: '#71717B' }}>{item.label}</span>
                                                <span style={{ color: item.color || "inherit", fontSize: '14px' }}>
                                                    {item.value}
                                                </span>
                                            </div>
                                        );
                                    }

                                    return (
                                        <div className="col-md-4 mb-2" key={index}>
                                            <span style={{ fontSize: '15px', fontWeight: '550', color: '#71717B' }}>{item.label}</span>
                                            <span
                                                style={{
                                                    color: item.color || "inherit",
                                                    fontWeight: item.bold ? "bold" : "normal",
                                                    fontSize: '14px'
                                                }}
                                            >
                                                {item.value}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* Customer Details */}
                        <div className="d-flex align-items-center mb-3 mt-3">
                            <h5
                                style={{
                                    color: "#005194",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Customer Details
                            </h5>
                            <hr
                                style={{
                                    flex: 1,
                                    borderTop: "2px solid #005194",
                                    marginTop: "10px",
                                }}
                            />
                        </div>

                        <div className="container">
                            <div className="row">
                                {customerDetails.map((item, index) => {
                                    const handleCopy = (text) => {
                                        navigator.clipboard.writeText(text);
                                        openPopup("Copied to clipboard!", "success");
                                    };

                                    if (item.half) {
                                        return (
                                            <div className="col-md-6 mb-2 d-flex align-items-start" key={index}>
                                                <div style={{ flex: 1 }}>
                                                    <span style={{ fontSize: '15px', fontWeight: '550', color: '#71717B' }}>{item.label}</span>
                                                    <span
                                                        style={{
                                                            fontWeight: item.bold ? "bold" : "normal",
                                                            fontSize: '14px',
                                                            wordBreak: 'break-word'
                                                        }}
                                                    >
                                                        {item.value}
                                                    </span>
                                                </div>

                                                {/* ✅ Show Copy button only for Address & Location */}
                                                {item.copy && (
                                                    <FaCopy
                                                        onClick={() => handleCopy(item.value)}
                                                        title="Copy to clipboard"
                                                        style={{
                                                            cursor: "pointer",
                                                            color: "#0d6efd",
                                                            fontSize: "16px",
                                                            marginLeft: "4px",
                                                        }}
                                                    />
                                                )}

                                            </div>
                                        );
                                    }

                                    return (
                                        <div className="col-md-4 mb-2" key={index}>
                                            <span style={{ fontSize: '15px', fontWeight: '550', color: '#71717B' }}>{item.label}</span>
                                            <span
                                                style={{
                                                    fontWeight: item.bold ? "bold" : "normal",
                                                    fontSize: '14px'
                                                }}
                                            >
                                                {item.value}
                                            </span>
                                        </div>
                                    );
                                })}

                            </div>
                        </div>

                        {/* Product Details */}
                        <div className="d-flex align-items-center mb-3 mt-3">
                            <h5
                                style={{
                                    color: "#005194",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Product Details
                            </h5>
                            <hr
                                style={{
                                    flex: 1,
                                    borderTop: "2px solid #005194",
                                    marginTop: "10px",
                                }}
                            />
                        </div>

                        {/* Product Details Grid */}
                        <div className="container">
                            {Array.isArray(productDetails) &&
                                productDetails.map((product, productIndex) => (
                                    <div key={productIndex} className="row mb-4 border-bottom pb-3">
                                        <div className="col-12 mb-2">
                                            <h6
                                                style={{
                                                    fontWeight: "600",
                                                    color: "#FF692A", // A nice blue accent
                                                    fontSize: "16px",
                                                    marginBottom: "8px",
                                                }}
                                            >
                                                Product {productIndex + 1}
                                            </h6>
                                        </div>

                                        {Array.isArray(product) &&
                                            product.map((item, index) => (
                                                <div
                                                    className={item.fullWidth ? "col-12 mb-2" : "col-md-4 mb-2"}
                                                    key={index}
                                                >
                                                    <span
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: "550",
                                                            color: "#71717B",
                                                            marginRight: "4px",
                                                        }}
                                                    >
                                                        {item.label}
                                                    </span>
                                                    <span
                                                        style={{
                                                            color: item.color || "inherit",
                                                            fontWeight: item.bold ? "bold" : "normal",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        {item.value}
                                                    </span>
                                                </div>
                                            ))}
                                    </div>
                                ))}
                        </div>


                        {/* Execution Details */}
                        <div className="d-flex align-items-center mb-3 mt-3">
                            <h5
                                style={{
                                    color: "#005194",
                                    fontWeight: "bold",
                                    marginRight: "10px",
                                }}
                            >
                                Execution Details
                            </h5>
                            <hr
                                style={{
                                    flex: 1,
                                    borderTop: "2px solid #005194",
                                    marginTop: "10px",
                                }}
                            />
                        </div>

                        {/* Execution Details Grid */}
                        <div className="container">
                            {Array.isArray(executionDetails) &&
                                executionDetails.map((execution, executionIndex) => (
                                    <div key={executionIndex} className="row mb-4 border-bottom pb-3">
                                        <div className="col-12 mb-2">
                                            <h6
                                                style={{
                                                    fontWeight: "600",
                                                    color: "#FF692A", // A nice blue accent
                                                    fontSize: "16px",
                                                    marginBottom: "8px",
                                                }}
                                            >
                                                Execution {executionIndex + 1}
                                            </h6>
                                        </div>

                                        {Array.isArray(execution) &&
                                            execution.map((item, index) => (
                                                <div
                                                    className={item.fullWidth ? "col-12 mb-2" : "col-md-4 mb-2"}
                                                    key={index}
                                                >
                                                    <span
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: "550",
                                                            color: "#71717B",
                                                            marginRight: "4px",
                                                        }}
                                                    >
                                                        {item.label}
                                                    </span>
                                                    <span
                                                        style={{
                                                            color: item.color || "inherit",
                                                            fontWeight: item.bold ? "bold" : "normal",
                                                            fontSize: "14px",
                                                        }}
                                                    >
                                                        {item.value}
                                                    </span>
                                                </div>
                                            ))}
                                    </div>
                                ))}
                        </div>

                    </CardBody>
                </Card>
            </Container>

            {
                isPopupVisible && (
                    <PopupWindow
                        message={popupMessage}
                        type={popupType}
                        onClose={closePopup}
                    />
                )
            }
        </div >
    );
};

WorkOrderDetails.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(WorkOrderDetails);
